import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import Header from './Components/Header';
import { setVodacomHeaderVisibility } from 'src/Utility/utility';

const NewCustomerRouteWrapper = ({ component: Component, ...rest }) => {
  const pathComponents = rest.location.pathname.toUpperCase().split('/');
  const currentPath = pathComponents[pathComponents.length - 1];
  
  React.useEffect(() => {
    //hide the header
    setVodacomHeaderVisibility(false);
    return () => {
      //   un-hide the header
      const visibilityFlag = !!(window.isFtthMA)
      setVodacomHeaderVisibility(!visibilityFlag);
    };
  }, []);

  return (
    <Route {...rest}>
      <Header currentPath={currentPath} history={rest.history} />
      <Component history={rest.history} />
    </Route>
  );
};

NewCustomerRouteWrapper.propTypes = {
  component: PropTypes.node.isRequired
};

export default NewCustomerRouteWrapper;
